import * as React from 'react';
import { styled } from '@mui/system';

const ProfileImg = styled('div')({
  display: 'flex',
  borderRadius: '75px',
  marginTop: '60px',
  '& img': {
    width: '150px',
    height: '150px',
    borderRadius: '75px',
    objectFit: 'cover',
  },
});

const UserProfileImage = (props) => {
  const { img, alt } = props;
  return (
    <ProfileImg>
      <img src={img} alt={alt} />
    </ProfileImg>
  );
};

export default UserProfileImage;
